"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Modal = require("@insided/shared/uikit/Modal");

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _Textarea = _interopRequireDefault(require("../ui-components/Textarea"));

var _common = require("@insided/shared/utils/common");

var _axios = _interopRequireDefault(require("axios"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _GroupSelector = _interopRequireDefault(require("../../control/modules/Groups/GroupSelector"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var joinCommunity = 'Join community';
var joinCommunityAndGroup = 'Join community and a group';

var ContactInviteModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContactInviteModal, _Component);

  var _super = _createSuper(ContactInviteModal);

  function ContactInviteModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContactInviteModal);
    _this = _super.call(this, props);

    _this.setState({
      inviteType: joinCommunity,
      inviteTypeChoices: [joinCommunity],
      customMessage: '',
      selectGroupError: '',
      groups: []
    });

    _this.sendInvite = _this.sendInvite.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ContactInviteModal, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_common.common.isModuleActive('group')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return _axios.default.get('/group/list').then(function (res) {
                  _this2.setState({
                    groups: res.data,
                    inviteTypeChoices: [joinCommunity, joinCommunityAndGroup]
                  });
                }).catch(function () {});

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "sendInvite",
    value: function () {
      var _sendInvite = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this3 = this;

        var _this$state, inviteType, groupId, customMessage, isGroupInvite;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$state = this.state, inviteType = _this$state.inviteType, groupId = _this$state.groupId, customMessage = _this$state.customMessage;

                if (!(inviteType === joinCommunityAndGroup && !groupId)) {
                  _context2.next = 4;
                  break;
                }

                this.setState({
                  selectGroupError: 'Please select a group.'
                });
                return _context2.abrupt("return");

              case 4:
                isGroupInvite = inviteType === joinCommunityAndGroup;
                _context2.next = 7;
                return _axios.default.post('/contact/invite', {
                  customMessage: customMessage,
                  groupId: isGroupInvite ? groupId : null,
                  importId: this.props.importId
                }).then(function () {
                  _this3.props.onContactsInvited(true, isGroupInvite);
                }).catch(function () {
                  return _this3.props.onContactsInvited(false, isGroupInvite);
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendInvite() {
        return _sendInvite.apply(this, arguments);
      }

      return sendInvite;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          contactCount = _this$props.contactCount,
          _onClose = _this$props.onClose;
      var _this$state2 = this.state,
          inviteTypeChoices = _this$state2.inviteTypeChoices,
          inviteType = _this$state2.inviteType,
          selectGroupError = _this$state2.selectGroupError,
          customMessage = _this$state2.customMessage,
          groups = _this$state2.groups;
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: isOpen,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Send invite to ".concat(contactCount, " contact").concat(contactCount > 1 ? 's' : ''),
        onClose: function onClose() {
          return _onClose();
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
        className: "contact-invite-modal"
      }, (0, _preact.h)(_RadioInputGroup.default, {
        title: "Invite contacts to",
        options: inviteTypeChoices,
        onChange: function onChange(option) {
          return _this4.setState({
            inviteType: option,
            selectGroupError: ''
          });
        },
        value: inviteType,
        underneath: true
      }), groups.length > 0 && (0, _preact.h)("div", {
        className: "group-select-wrapper"
      }, (0, _preact.h)(_InputGroup.default, {
        customInput: (0, _preact.h)(_GroupSelector.default, {
          groups: groups,
          onGroupSelected: function onGroupSelected(groupId) {
            return _this4.setState({
              groupId: groupId,
              selectGroupError: ''
            });
          },
          disabled: inviteType === joinCommunity
        }),
        error: selectGroupError
      })), (0, _preact.h)("label", {
        className: "contact-invite-modal__textarea-label"
      }, "Invite message"), (0, _preact.h)("div", null, "It\u2019s more likely for people to accept an invite if there is a personalised message attached."), (0, _preact.h)(_Textarea.default, {
        adjustHeight: true,
        class: "contact-invite-modal__textarea",
        placeholder: "e.g. Nice to meet you at the event, let\u2019s stay in touch in the community.",
        newStyle: true,
        onContentChange: function onContentChange(value) {
          return _this4.setState({
            customMessage: value
          });
        },
        value: customMessage
      }))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
        title: "Send invite via email",
        newStyle: true,
        onClick: this.sendInvite,
        size: "medium",
        variant: "brand"
      })));
    }
  }]);
  return ContactInviteModal;
}(_preact.Component);

var _default = ContactInviteModal;
exports.default = _default;